import { ProviderHealthDetail } from "@/features/oversight/monitoring";

export default function MonitoringProviderPage() {
  return <ProviderHealthDetail />;
}
